/**
 * Converts a hexadecimal color string to an RGBA color string with an alpha value of 0.15.
 *
 * @param hex - The hexadecimal color string (e.g. '#ff0000' for red).
 * @returns An RGB color string with an alpha value of 0.15 (e.g. 'rgba(255, 0, 0, 0.15)').
 */
export const getRGBAColor = (hex: string) => {
  if (!hex) return '#fff';

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, 0.15)`;
};
